module.exports = __webpack_public_path__ + "img/login-main-logo.58a307aa.svg";